<template>
    <div style="width:95%;margin:0 auto;">
        <h3 style="text-align:left;" >问：<span  v-html="title"></span></h3>
        <p ><h3 style="text-align:left;">答：</h3><span style="text-align:left;"  v-html="answer"></span></p>
        <li style="height:30px;margin-top:15px;">
          <el-button type="primary" icon="el-icon-arrow-left" size="small" @click="$router.back(-1)">返回</el-button>
        </li> 
    </div>
</template>

<script>
  import axios from 'axios'
  import { Message } from 'element-ui'

  export default {
      data(){
          return {
              id: '',
              title: '',
              answer: ''
          }
      },
      created() {
          this.id = this.$route.query.id
          console.log(this.id)
          this.getDetailById()
      },
      methods: {
        getDetailById() {
            const getTimestamp = new Date().getTime()
            axios.get(`/commonproblem/detail/${this.id}?timer=${getTimestamp}`).then(res => {
                console.log(res.data)
                if(res.data.respCode == "0000") {
                    this.title = res.data.data.title
                    this.answer = res.data.data.answer
                } else {
                    console.log(res.data.errMsg)
                    Message({
                        message: res.data.errMsg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                Message({
                    message: err,
                    type: 'error'
                })
            })
        },
        goBack() {
            this.router.go(-1)
        }
      }
      
  }
</script>


<style>

li {
  list-style-type:none;
  height: 50px;
  text-align: left;
}
ul {
  margin: 0 auto
}

</style>


// WEBPACK FOOTER //
// src/components/Detail.vue